export default "__VITE_ASSET__fyA3qOVk__"